<template>
    <el-row :gutter="25">
      <el-col :span="5">
        <el-form-item :label="$locale('accountPayable.accountPayableDetail') + '*'">
          <el-input v-model="form.name" :placeholder="$locale('accountPayable.placeholder.accountPayableDetail')" @input="setProp"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$locale('accountPayable.th.requestDeadDate') + '*'">
          <CommDatePicker
            v-model="form.requestDeadDate"
            :value.sync="form.requestDeadDate"
            width="100%"
            :showWeekly="true"
            :placeholder="$locale('setting.emergency.p.stoptime')"
            @change="setProp"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$locale('accountPayable.th.paymentDueDate')">
          <CommDatePicker
            v-model="form.payDate"
            :value.sync="form.payDate"
            width="100%"
            :showWeekly="true"
            :placeholder="$locale('setting.emergency.p.stoptime')"
            @change="setProp"
          />
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item :label="$locale('accountPayable.th.recordAmount') + '/' + $locale('accountPayable.invoiceAmount') + '*'">
          <el-input v-model="form.needPayAmount" :placeholder="$locale('accountPayable.placeholder.recordAmount')" @input="inputNum(true)" @blur="inputNum(false)"></el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="5">
        <el-form-item :label="$locale('accountPayable.billMonth')">
          <el-date-picker v-model="form.billMonthDate" type="month" value-format="timestamp" @change="setProp"></el-date-picker>
        </el-form-item>
      </el-col> -->
    </el-row>
</template>

<script>
import CommDatePicker from "@/components/common/CommDatePicker";

export default {
  name: "AccountPayableBasicModule",
  data() {
    return {
      form: {},
    };
  },
  methods: {
    setProp() {
      let needPayAmount = parseInt(this.form.needPayAmount.toString().replace(/[^\d-]/g, "")) || 0;

      this.$emit("setBasicForm", {
        name: this.form.name,
        requestDeadDate: this.form.requestDeadDate,
        payDate: this.form.payDate,
        needPayAmount: needPayAmount,
        // billMonthDate: this.form.billMonthDate,
      });
    },
    dayHandle(date, keyName) {
      let obj = { ...this.form };

      obj[keyName] = date;

      this.form = obj;
      this.setProp();
    },
    inputNum(isInput = true) {
      let num = this.form.needPayAmount.toString().replace(/[^\d-]/g, "");

      if (!isInput) {
        num = parseInt(num) || 0;
      }

      this.form = { ...this.form, needPayAmount: num };
      this.setProp();
    },
    createForm() {
      return {
        name: "",
        requestDeadDate: 0,
        payDate: 0,
        needPayAmount: "",
      }
    },
  },
  mounted() {
    let form = { ...this.createForm(), ...this.propForm };

    this.form = form;
  },
  props: {
    propForm: {
      type:Object,
      default: () => {},
    },
  },
  watch: {},
  components: {
    CommDatePicker,
  },
};
</script>
